import { getCheckedTreeKeysSessionKey } from "./getCheckedTreeKeysSessionKey";

export function getCheckedTreeKeysFromSession(projectId: string): string[] | undefined {
  const key = getCheckedTreeKeysSessionKey(projectId);
  return JSON.parse(sessionStorage.getItem(key)) || undefined;
}
